import { uniqBy } from 'lodash-es';
import { GOOGLE_PLACES_DEFAULT_TYPES } from '../constants';
import { PlacesAutocompleteOption } from '../interfaces';

export type GetPlacesCallback = (request: { input: string; types?: string[] }) => Promise<PlacesAutocompleteOption[]>;

export const getPlaceAutocompleteOptions = async (
	inputValue: string,
	getPlaceOptions: GetPlacesCallback,
	defaultOption?: PlacesAutocompleteOption
) => {
	let places = await getPlaceOptions({
		input: inputValue,
		types: ['(cities)'],
	});

	if (places.length < 5) {
		const addresses = await getPlaceOptions({
			input: inputValue,
			types: GOOGLE_PLACES_DEFAULT_TYPES.split('|'),
		});

		places = [...places, ...(places.length ? addresses.slice(0, -places.length) : addresses)];
	}

	const newOptions = uniqBy(defaultOption ? [...places, defaultOption] : [...places], 'id');

	return newOptions;
};
